export const BASEAPI = process.env.REACT_APP_API_URL
export const BASEAMIPOSAPI = process.env.REACT_APP_API_URL
export const REACT_APP_FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL
